import Vue from "vue";

Vue.directive("focus", {
    inserted: function (el) {
        el.focus();
    },
    update: function (el) {
        Vue.nextTick(function () {
            el.focus();
        });
    },
});

Vue.directive("click-outside", {
    bind: function (element, binding) {
        element.clickOutsideEvent = function (event) {
            if (!(element === event.target || element.contains(event.target))) {
                binding.value(event, element);
            }
        };
        document.body.addEventListener("click", element.clickOutsideEvent);
    },
    unbind: function (element) {
        document.body.removeEventListener("click", element.clickOutsideEvent);
    },
});
